export default __webpack_public_path__ + "assets/png/7cc8f8db35031f60229c0ec5944c7777.png";